var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroNavQuickTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.007,
    viewBox: "0 0 24 24.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,24H1a1,1,0,0,1,0-2H9a1,1,0,0,1,0,2Z",
    fill: "#7e7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,20H1a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z",
    fill: "#7e7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,16H1a1,1,0,0,1,0-2H5a1,1,0,0,1,0,2Z",
    fill: "#7e7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,23.955a1,1,0,1,1-.089-2A10,10,0,1,0,2.041,11.09a1,1,0,1,1-1.992-.18A12,12,0,1,1,13.09,23.951C13.06,23.954,13.029,23.955,13,23.955Z",
    fill: "#7e7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6a1,1,0,0,0-1,1v5a1,1,0,0,0,.293.707l3,3a1,1,0,1,0,1.414-1.414L13,11.586V7a1,1,0,0,0-1-1Z",
    fill: "#7e7c7c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroNavQuickTime);
export default __webpack_public_path__ + "static/media/Asset-KuroNavQuickTime.43dcdfa79e1bf4082df52331051232fe.svg";
export { ForwardRef as ReactComponent };